import script from "./system-version-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./system-version-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./system-version-distribution-chart.vue?vue&type=style&index=0&id=34b429c7&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b429c7"]])

export default __exports__